import { z } from 'zod/v4';

export const whitelistedConfigurationSettingSchema = z.object({
  configurationGroup: z.string().min(1),
  configurationKey: z.string().min(1),
  configurationType: z
    .literal('Integer')
    .or(z.literal('Boolean'))
    .or(z.literal('String')),
  configurationDefaultValue: z.string(),
  deprecated: z.boolean(),
});

export type WhitelistedConfigurationSetting = z.infer<
  typeof whitelistedConfigurationSettingSchema
>;
